import * as allActions from "../actions.constants";

// Action creators
export const setEmailAction = (data) => ({
  type: allActions.SET_EMAIL_ACTION,
  payload: data,
});

export const clearEmailAction = () => ({
  type: allActions.CLEAR_EMAIL_ACTION,
});
